import styled from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

export const TitleContainer = styled.div`
	display: flex;
	column-gap: 18px;
	margin-bottom: 38px;
`;

export const Heading = styled.div`
	display: flex;
	flex-direction: column;
	${fontMixins(32, 700)};
	color: ${COLORS.Black};
`;

export const Description = styled.div`
	display: flex;
	${fontMixins(14, 400)};
	color: #606060;
	margin-top: 10px;
`;
